module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei1.svg";